<ng-container
  *ngFor="
    let division of divisions;
    index as divisionIndex;
    first as isFirstDivision;
    last as isLastDivision
  "
>
  <my-bill-odb-division-identifier
    [identifier]="division.identifier"
    [type]="division.type"
    [hasDivisionIdentifierAtFirstPosition]="
      isFirstDivision && firstIdentifierHasClassRsTit4
    "
    [attr.data-cy]="testIDPrefix + '_division_' + divisionIndex"
  >
  </my-bill-odb-division-identifier>
  <my-bill-cover-details-division
    [division]="division"
    (categoryClick)="categoryClick.emit($event)"
    *ngIf="division.summaryCategories"
  ></my-bill-cover-details-division>
  <div class="rs-me" *ngIf="!isLastDivision && divisions.length > 1"></div>
</ng-container>
